import BaseModel from '../model/BaseModel';
import Genre from './Genre';
import VistaDate from '../model/VistaDate';
import MovieSession from '../model/MovieSession';
import MovieImage from '../model/MovieImage';
import MovieService from '../service/movie-service'
import PreviewService from '../service/preview-service'
import ModelArray from './ModelArray';
import Collection from './Collection'

/**
 * Collection of movies with Methods to format the movies into usable objects.
 */
export class Movies extends Collection {

    constructor(data) {
        super()
        this.data = new ModelArray(data, Movie);
        this._movies_cache = undefined;
    }

    featured() {
        return this.data.filter((m)=>m.featured === true)
    }

    openingDateDesc(a,b) {
        if (a.opening_date.timestamp < b.opening_date.timestamp)
            return -1;
        // if (a.last_nom > b.last_nom)
        //     return 1;

        return 0;
    }

    byRelease() {
        let data = this.data.reduce((c, m)=> {
            if (m.now_showing === true)
                c.now_showing.push(m);
            else
                c.coming_soon.push(m);
            return c;
        }, {
            now_showing: [],
            coming_soon: [],
        })

        data.coming_soon.sort(this.openingDateDesc)
        return data
    }

    byHasSessions() {
        return this.data.reduce((c, m) => {
            if(m.has_sessions_available === true)
                c.now_showing.push(m);
            return c;
        }, {
            now_showing: [],
            coming_soon: [],
        })
    }


    related(movie) {
        return this._filterGenres(movie.genres.map((g)=> {if(g && g != undefined) return g.id}));

    }

    findById(id) {
        return this.data.find((m)=>m.id == id)
    }

    findByName(name) {
        return this.data.find((m)=>m.title.toLowerCase() === name.toLowerCase())
    }

    getCinemaIds() {

        if (!this._movies_cache) {
            this._movies_cache = {};
            for (let m in MovieService.sessions) {
                for (let s in MovieService.sessions[m]) {
                    this._movies_cache[s] = s;
                }
            }
        }

        return Object.keys(this._movies_cache);

    }

    findBySessionId(SessionId, CinemaID) {
        return this.data.find((m)=> {
            return m.cinemas[CinemaID] ? ~m.cinemas[CinemaID].findIndex((s)=>s.id === SessionId.toString()) : false;
        })
    }

    getNames() {
        return this.data.map((m)=>m.title);
    }

    _filterTitle(title, movies = this.data) {
        return movies.filter((m)=> {
            var search = new RegExp(title.replace(/[^\w\s]/gi, '').replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "").replace(' ', '').toLowerCase(), "i")
            var mTitle = m.title.replace(/[^\w\s]/gi, '').replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "").replace(' ', '').toLowerCase()
            return search.test(mTitle);
        })
    }

    _filterCinemas(cinema_id, movies = this.data) {
        // console.log("filter - cinema id",cinema_id)
        let filteredMovies = []

        for(let m in movies) {
            for(let c in movies[m].cinemas) {
                for(let s in movies[m].cinemas[c]) {
                    if(movies[m].cinemas[c][s].cinema_id == cinema_id) {
                        let exists = false

                        if(filteredMovies.length > 0) {
                            for(let fm in filteredMovies) {
                                if(filteredMovies[fm].id == movies[m].id) {
                                    exists = true
                                }
                            }
                        }

                        if(!exists) {
                            filteredMovies.push(movies[m])
                        }
                    }
                }
            }
        }

        return filteredMovies
        // return movies.filter((m)=>m.cinemas.hasOwnProperty(cinema_id))
    }

    _filterExperiences(array_of_experiences, cinema_id, movies = this.data, time_range) {
        let filteredMovies = []

        // console.log("hit _filterExperiences", cinema_id, array_of_experiences)

        for(let m in movies) {
            for(let c in movies[m].cinemas) {
                for(let s in movies[m].cinemas[c]) {
                    for(let e in movies[m].cinemas[c][s].experiences) {
                        for(let ae in array_of_experiences) {
                            if(movies[m].cinemas[c][s].experiences[e] != undefined && movies[m].cinemas[c][s].experiences[e] != null && array_of_experiences[ae] != undefined && array_of_experiences[ae] != null) {
                                if(movies[m].cinemas[c][s].experiences[e].name == array_of_experiences[ae]) {
                                    if(cinema_id != null) {
                                        if(movies[m].cinemas[c][s].cinema != undefined && movies[m].cinemas[c][s].cinema != null) {
                                            if(cinema_id == movies[m].cinemas[c][s].cinema.id) {
                                                let exists = false

                                                if(filteredMovies.length > 0) {
                                                    for(let fm in filteredMovies) {
                                                        if(filteredMovies[fm].id == movies[m].id) {
                                                            exists = true
                                                        }
                                                    }
                                                }

                                                if(!exists) {
                                                    filteredMovies.push(movies[m])
                                                }
                                            }
                                        }
                                    } else {
                                        let exists = false

                                        if(filteredMovies.length > 0) {
                                            for(let fm in filteredMovies) {
                                                if(filteredMovies[fm].id == movies[m].id) {
                                                    exists = true
                                                }
                                            }
                                        }

                                        if(!exists) {
                                            filteredMovies.push(movies[m])
                                        }
                                    }
                                }
                            }
                        }    
                    }
                }
            }
        }

        // console.log("filteredMovies by type", filteredMovies)

        // for(let m in filteredMovies) {
        //     console.log(filteredMovies[m].title)
        //     console.log(filteredMovies[m].id)
        //     for(let c in movies[m].cinemas) {
        //         for(let s in movies[m].cinemas[c]) {
        //             for(let e in movies[m].cinemas[c][s].experiences) {
        //                 console.log(movies[m].cinemas[c][s].experiences[e].name)
        //             }
        //         }
        //     }
        // }

        // console.log("end _filterExperiences", filteredMovies)

        return filteredMovies
        // if (cinema_id) {
        //     return movies.filter((m)=> {
        //         let CinemaSessions = m.cinemas[cinema_id];
        //         return CinemaSessions && CinemaSessions.some((s)=> s && s.experiences && s.experiences[0] && ~array_of_experiences.indexOf(s.experiences[0].name)
        //             )
        //     })
        // } else
        //     return movies.filter((m)=>m.experiences.some((e)=>~array_of_experiences.indexOf(e)))
    }

    _filterGenres(array_of_genres, movies = this.data) {

        // console.log("hit _filterGenres", array_of_genres)
        let filteredMovies = []

        for(let m in movies) {
            for(let g in movies[m].genres) {
                for(let ag in array_of_genres) {
                    if(movies[m] != undefined && movies[m] != null) {
                        if(movies[m].genres[g] != undefined && movies[m].genres[g] != null && array_of_genres[ag] != undefined) {
                            if(movies[m].genres[g].id == array_of_genres[ag]) {
                                let exists = false

                                if(filteredMovies.length > 0) {
                                    for(let fm in filteredMovies) {
                                        if(filteredMovies[fm] != undefined && filteredMovies[fm] != null) {
                                            if(filteredMovies[fm].id == movies[m].id) {
                                                exists = true
                                            }
                                        }
                                    }
                                }

                                if(!exists) {
                                    filteredMovies.push(movies[m])
                                }
                            }
                        }
                    }
                }
            }
        }

        // console.log()
        // return movies.filter((m)=>m.genres.some((g)=>~array_of_genres.indexOf(g.id)))

        // console.log("end _filterGenres", filteredMovies)
        return filteredMovies
    }

    _filterByTime(time_range, movies = this.data, cinema_id, selected_types) {

        let filteredMovies = []
        // console.log("hit _filterByTime", time_range, cinema_id, selected_types)
        for(let m in movies) {
            // console.log(movies[m])
            if(movies[m].cinemas != undefined && movies[m].cinemas != null) {
                if(typeof movies[m].cinemas == "object") {
                    // console.log(movies[m].cinemas)
                    for(let c in movies[m].cinemas) {
                        if(movies[m].cinemas[c] != undefined && movies[m].cinemas[c] != null) {

                            if(typeof movies[m].cinemas[c] == "object") {
                                // console.log(movies[m].cinemas[c])
                                // console.log(movies[m].cinemas[c])
                                for(let s in movies[m].cinemas[c]) {
                                    if(movies[m].cinemas[c][s] != undefined && movies[m].cinemas[c][s] != null) {
                                        if(typeof movies[m].cinemas[c][s] == "object") {
                                            // console.log(movies[m].cinemas[c][s])
                                            for(let t in time_range.ranges) {
                                                if(time_range.ranges[t] != undefined && time_range.ranges != null) {

                                                    if(typeof time_range.ranges[t] == "object") {
                                                        // console.log(time_range.ranges[t])  

                                                        if(cinema_id > 0) {
                                                            if(movies[m].cinemas[c][s].time_tag != undefined && movies[m].cinemas[c][s].time_tag != null) {
                                                                if(movies[m].cinemas[c][s].cinema != null && movies[m].cinemas[c][s].cinema != undefined) {
                                                                    // console.log(movies[m].cinemas[c][s].cinema)
                                                                    if(movies[m].cinemas[c][s].time_tag.includes(time_range.ranges[t].hour+":") && movies[m].cinemas[c][s].cinema.id == cinema_id) {
                                                                        if(selected_types.length > 0) {
                                                                            // console.log(selected_types)
                                                                            for(let t in selected_types) {
                                                                                if(selected_types[t] != undefined && selected_types[t] != null) {
                                                                                    // console.log(selected_types[t])
                                                                                    if(movies[m].cinemas[c][s].experiences != undefined && movies[m].cinemas[c][s].experiences != null) {
                                                                                        // console.log(movies[m].cinemas[c][s].experiences)
                                                                                        for(let e in movies[m].cinemas[c][s].experiences) {
                                                                                            if(movies[m].cinemas[c][s].experiences[e] != undefined && movies[m].cinemas[c][s].experiences[e] != null) {
                                                                                                
                                                                                                if(movies[m].cinemas[c][s].experiences[e].name == selected_types[t]) {

                                                                                                    let exists = false
                                                                                                    
                                                                                                    if(filteredMovies.length > 0) {
                                                                                                        if(filteredMovies != undefined && filteredMovies != null) {

                                                                                                            for(let fm in filteredMovies) {
                                                                                                                if(filteredMovies[fm] != undefined && filteredMovies[fm] != null) {
                                                                                                                    if(movies[m].id != undefined && movies[m].id != null) {
                                                                                                                        if(filteredMovies[fm].id == movies[m].id) {
                                                                                                                            exists = true
                                                                                                                        }
                                                                                                                    }
                                                                                                                }
                                                                                                            }
                                                                                                        }
                                                                                                    }

                                                                                                    if(!exists) {
                                                                                                        filteredMovies.push(movies[m])
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }

                                                                        } else {
                                                                            let exists = false

                                                                            if(filteredMovies != undefined && filteredMovies != null) {
                                                                                if(filteredMovies.length > 0) {
                                                                                    for(let fm in filteredMovies) {
                                                                                        if(filteredMovies[fm] != undefined && filteredMovies[fm] != null) {
                                                                                            if(filteredMovies[fm].id == movies[m].id) {
                                                                                                exists = true
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }

                                                                                if(!exists) {
                                                                                    filteredMovies.push(movies[m])
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        } else {

                                                            if(movies[m].cinemas[c][s].time_tag != undefined && movies[m].cinemas[c][s].time_tag != null) {
                                                                if(movies[m].cinemas[c][s].time_tag.includes(time_range.ranges[t].hour+":")) {
                                                                    if(selected_types.length > 0) {
                                                                        // console.log(selected_types)
                                                                        for(let t in selected_types) {
                                                                            if(selected_types[t] != undefined && selected_types[t] != null) {
                                                                                // console.log(selected_types[t])
                                                                                if(movies[m].cinemas[c][s].experiences != undefined && movies[m].cinemas[c][s].experiences != null) {
                                                                                    // console.log(movies[m].cinemas[c][s].experiences)
                                                                                    for(let e in movies[m].cinemas[c][s].experiences) {
                                                                                        if(movies[m].cinemas[c][s].experiences[e] != undefined && movies[m].cinemas[c][s].experiences[e] != null) {
                                                                                            if(movies[m].cinemas[c][s].experiences[e].name == selected_types[t]) {
                                                                                                let exists = false
                                                                                                if(filteredMovies.length > 0) {
                                                                                                    if(filteredMovies != undefined && filteredMovies != null) {
                                                                                                        for(let fm in filteredMovies) {
                                                                                                            if(filteredMovies[fm] != undefined && filteredMovies[fm] != null) {
                                                                                                                if(movies[m].id != undefined && movies[m].id != null) {
                                                                                                                    if(filteredMovies[fm].id == movies[m].id) {
                                                                                                                        exists = true
                                                                                                                    }
                                                                                                                }
                                                                                                            }
                                                                                                        }
                                                                                                    }
                                                                                                }

                                                                                                if(!exists) {
                                                                                                    filteredMovies.push(movies[m])
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }

                                                                    } else {
                                                                        let exists = false

                                                                        if(filteredMovies != undefined && filteredMovies != null) {
                                                                            if(filteredMovies.length > 0) {
                                                                                for(let fm in filteredMovies) {
                                                                                    if(filteredMovies[fm] != undefined && filteredMovies[fm] != null) {
                                                                                        if(filteredMovies[fm].id == movies[m].id) {
                                                                                            exists = true
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }

                                                                            if(!exists) {
                                                                                filteredMovies.push(movies[m])
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            } 
                        }
                    }
                }
            }
        }
        // console.log("end _filterByTime", filteredMovies)
        // console.log(filteredMovies)
        return filteredMovies
    }

    filter(filter) {
        if(filter != undefined) {
            // console.log("Movies.filter hit", filter)
            if (typeof filter === 'string') return this._filterTitle(filter);
            else {

                var movies = this.data;
                // console.log("Movies.filter movies", movies)
                if (filter.cinemas) { 
                  movies = this._filterCinemas(filter.cinemas, movies);
                  // console.log("Movies.filter passed cinemas", filter.cinemas, movies)
                }
                
                if (filter.cinemas && filter.experiences && filter.experiences.length > 0) { 
                  movies = this._filterExperiences(filter.experiences, filter.cinemas, movies, filter.time_range);
                  // console.log("Movies.filter passed cinemas and experiences", filter.experiences, movies)
                } else if (filter.experiences && filter.experiences.length > 0) {
                  movies = this._filterExperiences(filter.experiences, null, movies, filter.cinemas);
                  // console.log("Movies.filter passed experiences", filter.experiences, movies)
                }
                
                if(filter.genres != undefined && filter.genres != null) {
                    // console.log("filter.genres", filter.genres)
                    if (filter.genres && filter.genres.length > 0) {
                        // console.log("filter.genres", filter.genres)
                        movies = this._filterGenres(filter.genres, movies);
                        // console.log("Movies.filter passed genres", filter.genres, movies)
                    }
                }

                // console.log("filter.time_range", filter.time_range)
                if (filter.time_range && filter.time_range != undefined && filter.time_range != null && typeof filter.time_range == "object") {
                    movies = this._filterByTime(filter.time_range, movies, filter.cinemas, filter.experiences);
                    // console.log("Movies.filter passed time_range", filter.time_range, movies)
                } else {
                    // console.log("no match for filter time", filter)
                }

                if (filter.title) { 
                    movies = this._filterTitle(filter.title, movies);
                    // console.log("Movies.filter passed title", filter.title, movies)
                }
                
                // console.log("cinemas", filter.cinemas)
                // console.log("Movies.filter end movies", movies)
                return movies;
            }
        }
    }
}


/**
 * Single Movie Object.
 */
export class Movie extends BaseModel {

    constructor(data) {
        super(data);
        this.id = data.id;
        this.title = data.title;
        this.title_slug = data.title_slug;
        this.search_title = data.search_title;
        this.runtime = data.runtime;
        this.runtime_hour_minute = {
            hours: data.runtime ? Math.floor(data.runtime / 60) : 0,
            minutes: data.runtime ? data.runtime % 60 : 0
        };
        this.runtime_string = `${this.runtime_hour_minute.hours}h${this.runtime_hour_minute.minutes}`;
        this.trailer_url = data.trailer_url;
        this.youtube_id = data.youtube_id;
        this.images = new MovieImage(data.images || {});
        this.poster = this.images.standard.desktop.url; // todo deprecate USE images.standard.desktop or images.standard.mobile instead.
        this.synopsis = data.synopsis;
        this.short_synopsis = data.short_synopsis;
        this.genres = data.genres && new ModelArray(data.genres, Genre) || [];
        this.coming_soon = Boolean(data.coming_soon);
        this.now_showing = Boolean(data.now_showing);
        this.has_sessions_available = Boolean(data.has_sessions_available);
        this.allow_ticket_sales = Boolean(data.allow_ticket_sales);
        this.film_festivals = data.film_festivals || [];
        this.experiences = data.experiences || [];
        this.sessions = data.sessions || [];
        this.time_tags = data.time_tags || [];
        this.date_tags = data.date_tags || [];
        this.flags = data.flags || [];
        this.opening_date = new VistaDate(data.opening_date);
        this.advance_booking_date = new VistaDate(data.advance_booking_date);
        this.loyalty_advance_booking_date = new VistaDate(data.loyalty_advance_booking_date);
        this.cinemas_cache = null;
        // if (data.cinemas) {
        //     Object.keys(data.cinemas).map((key)=>data.cinemas[key] = new ModelArray(data.cinemas[key], MovieSession));
        // }
        // this.cinemas = data.cinemas;
        this.expiry_time = data.expiry_time;
        this.rating = data.rating;

        this.promoMeta = data.promoMeta;
        this.eventMeta = data.eventMeta;
        this.featured = Boolean(data.featured);
        this.hasPromos = Boolean(data.hasPromos);
        this.hasEvents = Boolean(data.hasEvents);
        this.floodlight_tag = data.floodlight_tag;
        this.floodlight_pixel = data.floodlight_pixel;
        this.cast = data.cast;

        if (PreviewService.hasPreviewContentForRelatedMovie('promotion', this.id)) {
            let PreviewPromo = PreviewService.getPreviewContent('promotion');
            this.images.setPromo(PreviewPromo.images);
            this.hasPromos = true;
            this.promoMeta = {
                title: PreviewPromo.title || null,
                strapline: PreviewPromo.strapline || null,
                button_text: PreviewPromo.button_text || null,
                button_link: PreviewPromo.button_link || null,
                button_2_link: PreviewPromo.button_2_link || null,
                button_2_text: PreviewPromo.button_2_text || null,
                nid: PreviewPromo.nid || null,
                use_movie_poster: Boolean(PreviewPromo.use_movie_poster),
            }
        }

        if (PreviewService.hasPreviewContentForRelatedMovie('event', this.id)) {
            let PreviewEvent = PreviewService.getPreviewContent('event');
            this.images.setEvent(PreviewEvent.images);
            this.hasEvents = true;
        }
        // this.promos = data.promos || [];
        // this.events = data.events || [];
    }

    get cinemas() {
        if (!this.cinemas_cache) {
            var movieSessions =  MovieService.sessions[this.id];
            if (movieSessions) {
                this.cinemas_cache = {};
                Object.keys(movieSessions).map((key)=>this.cinemas_cache[key] = new ModelArray(movieSessions[key], MovieSession));
            }
        }

        return this.cinemas_cache;
    }

    getExperienceForCinema(cinema_id) {
        return this.cinemas[cinema_id] ? this.cinemas[cinema_id].reduce((c, s)=> {
            let exp = s.experiences.length == 1 ? s.experiences[0].name : undefined;
            if (exp && !~c.indexOf(exp)) c.push(exp);
            return c;
        }, []) : []
    }

    get genresString() {
        return this.genres.map((g)=>g.name).join('/')
    }

    get experiencesString() {
        return this.experiences.join(' ')
    }

    getSessions(cinemaId = null) {
        // return MovieService.getSessions(this.id, cinemaId).then((response)=> {
        //     var sessionCinemas = response.data;
        //     Object.keys(sessionCinemas).map((key)=>sessionCinemas[key] = new ModelArray(sessionCinemas[key], MovieSession));
        //     return this.cinemas = sessionCinemas;
        // })

        return this.cinemas;
    }


    getSession(sessionId) {
        return Object.keys(this.cinemas).reduce((arr, key)=>arr.concat(this.cinemas[key]), []).find((session)=>session.id == sessionId.toString())
    }

    /**
     * fetch more information about this movie.
     * @returns {Promise.<Movie>|*}
     */
    details() {
        return MovieService.getMovieDetail(this.id);
    }

    /**
     * get movies that are related to this movie.
     * @returns {Promise.<TResult>|*}
     */
    getRelatedMovies() {
        return MovieService.getRelatedMovies(this);
    }


}




// WEBPACK FOOTER //
// ../hasta-la-vista-middleware-api/src/model/Movies.js